/** Overrides WSOL global `.content` styles and applies theme surface colors to journal chrome. */
export const WSOL_CONTENT_BACKGROUND_FIX_ID = "bronte-journal-wsol-content-bg-fix";

const JOURNAL_PROMPT_SURFACE =
  "var(--surface-color, var(--background-color, transparent))";

export const WSOL_CONTENT_BACKGROUND_FIX_CSS = `
  .content {
    background: transparent !important;
  }

  #viewer-express-container .bronte-journal-plugin .content,
  #viewer-express-container .bronte-journal-plugin .wsol-st-head-wrap {
    background-color: ${JOURNAL_PROMPT_SURFACE} !important;
  }
`;

export function mountWsolContentBackgroundFix(): void {
  let styleEl = document.getElementById(
    WSOL_CONTENT_BACKGROUND_FIX_ID,
  ) as HTMLStyleElement | null;

  if (!styleEl) {
    styleEl = document.createElement("style");
    styleEl.id = WSOL_CONTENT_BACKGROUND_FIX_ID;
    document.head.appendChild(styleEl);
  }

  styleEl.textContent = WSOL_CONTENT_BACKGROUND_FIX_CSS;

  if (document.head.lastElementChild !== styleEl) {
    document.head.appendChild(styleEl);
  }
}
